import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  border: ${({ theme }) => `${rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border}`};
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const StyledImage = styled.div``;
export const StyledExtra = styled.div``;
export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: auto;
  height: fit-content;
`;
